import cx from 'classnames'
import { FC } from 'react'

import { WizardDataStatusInterface } from 'src/types/WizardDataStatusInterface'
import { WIZARD_STATUS } from 'src/utils/constant'
import { getWizardColorByStatusFn, getWizardStatusPlatformsFn } from 'src/utils/wizardUtils'

import * as styles from './WizardStatusContent.scss'

interface WizardStatusContentItemsProps {
  dashboard: WizardDataStatusInterface
}

const WizardStatusContentItems: FC<WizardStatusContentItemsProps> = ({ dashboard }) => {
  const { zero_revenue, type } = dashboard

  const isOk = type === WIZARD_STATUS.success

  const isInProgress = type === WIZARD_STATUS.in_progress

  const isInMaintenance = type === WIZARD_STATUS.in_maintenance

  const isWithZeroRevenue = Boolean(isOk && Object.keys(zero_revenue).length)

  const statusPlatforms = getWizardStatusPlatformsFn(dashboard)

  const color = getWizardColorByStatusFn(type)

  return (
    <div className={styles.Content}>
      {!isWithZeroRevenue && <div className={styles.ContentTitlePadding} />}
      {isInProgress && (
        <div className={cx(styles.ContentTitle, styles.ContentInProgressTitle)}>
          Data is currently being processed
        </div>
      )}
      {isWithZeroRevenue && (
        <div className={styles.ContentTitle}>
          <div className={styles.ContentTitleBorder} />
          Including {statusPlatforms.length} seats with zero revenue
        </div>
      )}

      {statusPlatforms.map(({ platforms, message }, index) => {
        return (
          <div key={index} className={styles.ContentItem}>
            <div
              className={cx(styles.ContentItemBorder, {
                [styles.ContentItemBorderLast]: index === statusPlatforms.length - 1,
              })}
            />
            <div
              className={cx(styles.ContentItemIcon, {
                [styles.ContentItemIconInMaintenance]: isInMaintenance,
              })}
            >
              <div className={styles.ContentItemIconColored} style={{ backgroundColor: color }} />
            </div>
            <div className={styles.ContentItemText}>
              <p>{platforms}</p>
              {message && <p className={styles.ContentItemTextMessage}>{message}</p>}
            </div>
          </div>
        )
      })}
      <div className={cx(styles.ContentTitle, styles.ContentSmartCollectTitle)}>
        (*) Smart collect feature is activated
      </div>
    </div>
  )
}

export default WizardStatusContentItems
